import { FailureReasonBaseData, FailureReasonUsage, QueryParams, QueryResult } from "common";
export interface FailureReasonQueryParams extends QueryParams {
    code?: string;
    externalCode?: string;
    name?: string;
    usage?: FailureReasonUsage;
    createdBy?: string;
    createdOnStart?: any;
    createdOnEnd?: any;
    updatedBy?: string;
    updatedOnStart?: any;
    updatedOnEnd?: any;
}

export const FAILURE_REASON_SORT_KEYS = ['name', 'code', 'externalCode', 'usage', 'active', 'createdBy', 'createdOnUtc', 'updatedBy', 'updatedOnUtc'];

export const isFailureReasonSort = (sort: string): boolean =>
    FAILURE_REASON_SORT_KEYS.includes(sort.replace(/^[-+]/, ''));

export interface FailureReasonData extends FailureReasonBaseData {
    id?: number;
	description?: string;
    active?: boolean;
    createdBy?: string;
    createdOn?: Date;
    updatedBy?: string;
    updatedOn?: Date;
}

export interface FailureReasonQueryResult extends QueryResult<FailureReasonData>
{
}

export class FailureReasonFilters {
    code: string;
    externalCode: string;
    name: string;
    usage: FailureReasonUsage;
    createdBy: string;
    createdOn: Date;
    createdOnStart: Date;
    createdOnEnd: Date;
    updatedBy: string;
    updatedOn: Date;
    updatedOnStart: Date;
    updatedOnEnd: Date;
    active: boolean;

    constructor(filters?) {
        filters = filters || {};
        this.code = filters.code || undefined;
        this.externalCode = filters.externalCode || undefined;
        this.name = filters.name || undefined;
        this.usage = filters.usage || undefined;
        this.createdBy =  filters.createdBy ? filters.createdBy.fullName ? filters.createdBy.fullName : filters.createdBy : undefined;
        this.createdOn = filters.createdOn || undefined;
        this.createdOnStart = filters.createdOnStart || undefined;
        this.createdOnEnd = filters.createdOnEnd || undefined;
        this.updatedBy =  filters.updatedBy ? filters.updatedBy.fullName ? filters.updatedBy.fullName : filters.updatedBy : undefined;
        this.updatedOn = filters.updatedOn || undefined;
        this.updatedOnStart = filters.updatedOnStart || undefined;
        this.updatedOnEnd = filters.updatedOnEnd || undefined;
        this.active = filters.active === 'true' ? true : (filters.active === 'false' ? false : undefined);
    }

    remove(item: string) {
        this[item] = undefined;
        if (item === 'createdOn' || item === 'createdOnStart') {
            this.createdOn = undefined;
            this.createdOnStart = undefined;
            this.createdOnEnd = undefined;
        } else if (item === 'updatedOn' || item === 'updatedOnStart') {
            this.updatedOn = undefined;
            this.updatedOnStart = undefined;
            this.updatedOnEnd = undefined;
        }
    }
}